var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType["SET"] = "SET";
    NotificationActionType["CLEAR"] = "CLEAR";
})(NotificationActionType || (NotificationActionType = {}));
var initialState = {
    type: undefined,
    messages: [],
};
var NotificationStateContext = React.createContext(initialState);
var NotificationDispatchContext = React.createContext(null);
var reducer = function (state, action) {
    switch (action.type) {
        case NotificationActionType.SET: {
            return action.payload || state;
        }
        case NotificationActionType.CLEAR: {
            return __assign(__assign({}, state), { messages: [] });
        }
        default: {
            return state;
        }
    }
};
var NotificationProvider = function (_a) {
    var children = _a.children;
    var initializer = function (state) { return state; };
    var _b = React.useReducer(reducer, initialState, initializer), state = _b[0], dispatch = _b[1];
    return (React.createElement(NotificationStateContext.Provider, { value: state },
        React.createElement(NotificationDispatchContext.Provider, { value: dispatch }, children)));
};
function useNotificationState() {
    var context = React.useContext(NotificationStateContext);
    if (!context) {
        throw new Error('NotificationStateContext undefined');
    }
    return context;
}
function useNotify() {
    var dispatch = React.useContext(NotificationDispatchContext);
    if (!dispatch) {
        throw new Error('NotificationDispatchContext undefined');
    }
    var notify = React.useCallback(function (type, messages) {
        dispatch({
            type: NotificationActionType.SET,
            payload: {
                type: type,
                messages: messages,
            },
        });
    }, [dispatch]);
    return notify;
}
function useClear() {
    var dispatch = React.useContext(NotificationDispatchContext);
    if (!dispatch) {
        throw new Error('NotificationDispatchContext undefined');
    }
    return function () {
        dispatch({ type: NotificationActionType.CLEAR });
    };
}
export { NotificationProvider, NotificationActionType, useNotificationState, useNotify, useClear, };
